/**
 * User-managed, non-secret Reviewer preferences.
 * Persisted in localStorage. Never stores tokens or API keys.
 */

export interface ReviewerPreferences {
  defaultQuickScan: boolean
  defaultIncludeAi: boolean
}

const PREFS_KEY = 'hmvm:reviewer:preferences'

const DEFAULTS: ReviewerPreferences = {
  defaultQuickScan: false,
  defaultIncludeAi: true,
}

export function loadReviewerPreferences(): ReviewerPreferences {
  try {
    const raw = localStorage.getItem(PREFS_KEY)
    if (!raw) return { ...DEFAULTS }
    const parsed = JSON.parse(raw) as Partial<ReviewerPreferences>
    return {
      defaultQuickScan: Boolean(parsed.defaultQuickScan),
      defaultIncludeAi:
        parsed.defaultIncludeAi === undefined ? true : Boolean(parsed.defaultIncludeAi),
    }
  } catch {
    return { ...DEFAULTS }
  }
}

export function saveReviewerPreferences(prefs: ReviewerPreferences): void {
  localStorage.setItem(PREFS_KEY, JSON.stringify(prefs))
}
